import script from "./PdIconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PdIconButton.vue?vue&type=script&setup=true&lang=js"

import "./PdIconButton.vue?vue&type=style&index=0&id=3052ea8f&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3052ea8f"]])

export default __exports__